import { render, staticRenderFns } from "./selectProject.vue?vue&type=template&id=2db8de5d&"
import script from "./selectProject.vue?vue&type=script&lang=ts&"
export * from "./selectProject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports